// extracted by mini-css-extract-plugin
export default {"prevArrow":"buddhism-lesson_prevArrow__JykeK","nextArrow":"buddhism-lesson_nextArrow__jNqow"};